<template>
  <div>
    <router-view v-if="loaded"></router-view>
  </div>
</template>

<script>
// import Loader from './components/Loader.vue'
import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import { AccountDetectionModeModule } from "@/InscriptionFlowsAdmin/store/modules/AccountDetectionModeModule";

export default Vue.extend({
  name: "inscription-flow",

  components: {},

  data() {
    return {
      accountDetectionModesModule: getModule(AccountDetectionModeModule),
      loaded: false
    };
  },

  computed: {},

  methods: {},

  watch: {},
  async created() {
    await this.accountDetectionModesModule.list();
    const myAdm = this.accountDetectionModesModule.accountDetectionModes.filter(
      adm => adm.code === this.$appSettings.IdAccountDetectionMode
    );

    if (myAdm && myAdm.length > 0) {
      this.accountDetectionModesModule.setFlowADM(myAdm[0]);
      this.loaded = true;
    }
  }
});
</script>

<style scoped></style>
